import Client from '../../../../tableEngine/Script/Game/Data/Service/Client';
import { PlayType } from '../../../../tableEngine/Script/Game/Data/Model/TableModel';
import LobbyRoundPlayGamePreviewData from '../DataObject/PreviewData/LobbyRoundPlayGamePreviewData';
import LobbySinglePlayGamePreviewData from '../DataObject/PreviewData/LobbySinglePlayGamePreviewData';
import LobbyMultiplePlayGamePreviewData from '../DataObject/PreviewData/LobbyMultiplePlayGamePreviewData';
import { LobbyMultiplePlayOverviewDataType, LobbyRoundPlayOverviewDataType, LobbySinglePlayOverviewDataType } from '../Config/LobbyGamePreviewDataType';
import ILobbyHallService from './ILobbyHallService';
import Lobby from '../../../System/Lobby';
import { LobbyPathName } from '../Config/LobbyPathConfig';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import ErrorName from '../../../../common/scripts/ErrorHandler/ErrorName';
import HistoryDetailData from '../DataObject/History/HistoryDetailData';
import LobbyHistoryData from '../DataObject/History/LobbyHistoryData';
import ILobbyHistoryService from './ILobbyHistoryService';

export default class LobbyClient extends Client implements ILobbyHallService, ILobbyHistoryService {
    public async getGameUrl(gameID: string, gameType: DataType.Enums.PlayType): Promise<string> {
        const response: DataType.Game.LaunchResponseData = await Lobby.connection.send(LobbyPathName.GameLaunch, {
            GameID: gameID,
            GameType: `${gameType}_play`,
            // GameDomain: gameType === DataType.Enums.PlayType.Single ? Lobby.define.s7GameDomain : Lobby.define.winslotGameDomain,
        });
        // return `http://192.168.127.200/game/streaming/winslot/?${response.GameURL.split('?')[1]}&ui=3`;
        // return `http://localhost:7458/?${(response?.GameURL ?? '').split('?')[1]}&ui=3`;
        // return `http://localhost:7457/?${(response?.GameURL ?? '').split('?')[1]}&ui=1`;
        const gameURL = response?.GameURL;
        if (gameURL?.includes('lang=')) {
            return gameURL.replace(/([?&])lang=[^&#]*/i, `$1lang=${Lobby.i18n.currentLanguage}`);
        }
        return gameURL?.concat(`&lang=${Lobby.i18n.currentLanguage}`);
    }

    public async getHistoryData(pageIndex: number, pageSize: number, startTime: number, endTime?: number, gameType?: DataType.Enums.PlayType) {
        const response: DataType.History.ResponseData = await Lobby.connection.send(
            LobbyPathName.History,
            {
                // 這邊使用秒為單位而非毫秒
                Page: pageIndex,
                PageSize: pageSize,
                StartTime: Math.trunc(startTime / 1000),
                EndTime: Math.trunc(endTime / 1000),
                Limit: 50,
                Offset: 0,
                GameType: `${gameType}_play`,
            },
            {
                expectedErrors: [ErrorName.SYSTEM_BUSY, ErrorName.SYSTEM_BUSY2],
            },
        );

        return response.Results.map((rawData) => this.instantiateHistoryData(rawData));
    }

    public async getHistoryDetailData(transactionID: string, roundID: number) {
        // TODO: S7 may need to return directly in Feature
        const response = await Lobby.connection.send(
            LobbyPathName.HistoryDetail,
            {
                TransactionID: transactionID,
                RoundID: roundID,
            },
            {
                expectedErrors: [ErrorName.SYSTEM_BUSY, ErrorName.SYSTEM_BUSY2],
            },
        );
        const detail: DataType.History.DetailData = JSON.parse(response.Detail);
        return this.instantiateHistoryDetailData(detail);
    }

    protected instantiateHistoryData(data: DataType.History.ResultData) {
        return new LobbyHistoryData(data);
    }

    protected instantiateHistoryDetailData(data: DataType.History.DetailData) {
        return new HistoryDetailData(data);
    }

    protected instantiateSinglePlayGamePreviewData(hallID: number, gameID: string, playType: PlayType, data: LobbySinglePlayOverviewDataType) {
        return new LobbySinglePlayGamePreviewData(hallID, gameID, playType, data);
    }

    protected instantiateMultiplePlayGamePreviewData(hallID: number, gameID: string, playType: PlayType, data: LobbyMultiplePlayOverviewDataType) {
        return new LobbyMultiplePlayGamePreviewData(hallID, gameID, playType, data);
    }

    protected instantiateRoundPlayGamePreviewData(hallID: number, gameID: string, playType: PlayType, data: LobbyRoundPlayOverviewDataType) {
        return new LobbyRoundPlayGamePreviewData(hallID, gameID, playType, data);
    }
}
